<template lang="pug">
div
	v-e24-nav-bar
	section.maincolumn-constrained
		form.login-form(name='form', novalidate v-on:submit.prevent="")
			.login-body
				h3 {{ $t('login.recoverPassTitle') }}
				span {{ $t('login.recoverText') }}
				br
				.alert.alert-warning(v-if='authReason') {{authReason}}
				.alert.alert-danger(v-if='authError') {{authError}}

				.login-lbl
					label {{ $t('label.userEmail') }}
					input.login-field(name='login', v-model='searchToRecover', required, autofocus, novalidate='')

				.btn-login-cnt
					b-button(variant="success", size="lg", @click='recover') {{ $t('label.ok') }}
	v-e24-footer(:build="build")

	md-dialog-alert(:md-active.sync='recoverySentDialogShow', :md-content='$t("user.dialogs.recoveryDataSent")')
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
import readBuild from '../../util/readBuild'

export default {
	name: 'ForgotPassword',
	data () {
		return {
			build: '',
			authError: '',
			authReason: '',
			searchToRecover: '',
			// Controls the "recovery email sent" dialog. Deliberately a plain
			// local dialog rather than the shared infoDialog action — infoDialog
			// is fire-and-forget with no close callback, and navigating away
			// only once the user has actually acknowledged the message needs one.
			recoverySentDialogShow: false
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	watch: {
		// MdDialogAlert's OK button only emits update:mdActive(false) — no
		// event distinguishing "confirmed" from any other dismissal, but on a
		// single-button alert there is no other dismissal, so the true->false
		// transition IS the user acknowledging the message. `.sync` on
		// md-active wires that transition into this data property (this is
		// the same pattern info.vue already uses for the same component); a
		// raw @update:md-active listener does not fire here, because
		// MdDialogAlert emits the camelCase event name 'update:mdActive'
		// verbatim and Vue does not case-convert custom event names the way
		// it does prop names.
		recoverySentDialogShow (isShowing, wasShowing) {
			if (wasShowing && !isShowing) {
				this.$router.push({name: 'connect', params: { goodbye: '', redirect: '' }})
			}
		}
	},
	methods: {
		...mapActions(['infoDialog']),

		recover () {
			var recoverEmail = ''

			if (this.searchToRecover !== '') {
				// Search
				Vue.jnx.userService.findOneByUsernameOrEmail(this.searchToRecover).then((userFound) => {
					console.log('user found', userFound)
					// Get Email in order to create invitation
					if (!_.isNil(userFound)) {
						console.log('findUserByUserName', userFound)
						const emails = userFound.contact.emailAddresses(false)
						if (!_.isNil(emails) && emails.length > 0) {
							// console.log('user found emails', emails)
							_.every(emails, (email) => {
								// TODO: Validate if it is a real email address
								if (email.address !== '') {
									// Register recovery
									recoverEmail = email.address
									Vue.jnx.userActionService.recoverPassword(userFound.userId, userFound.contact.id, recoverEmail).then((resp) => {
										this.recoverySentDialogShow = true
										console.log('Password recovery started', resp)
									})
									return false
								}
							})
						} else {
							this.infoDialog(this.$t('login.dialogs.recoverEmailNotFound'))
						}
					} else {
						this.infoDialog(this.$t('login.dialogs.usernameNotFound'))
					}
				})
			} else {
				this.infoDialog(this.$t(''))
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/forgot-password.vue